export default __webpack_public_path__ + "static/media/cardbanner.f3c814ed.png";